module.exports = __webpack_public_path__ + "static/media/sweat-time-logo.4df421df.png";